import moment from "moment";
import "moment-timezone";

const CommonUtil = {
  validateName(name) {
    return /^\d*[a-zA-Z][a-zA-Z0-9_ ]*$/.test(name);
  },

  checkCharactersGreaterThan250(text) {
    if (text.length > 250) return true;
    else return false;
  },

  checkCharactersGreaterThan50(text) {
    if (text.length > 50) return true;
    else return false;
  },
  isValidEmail(email) {
    if (email === undefined || email === "") return true;
    //const regex = /^(?!\.)(?!.*\.$)(?!.*?\.\.)+(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

    const regex = /^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^-]+(?:\.[a-zA-Z0-9_!#$%&'*+/=?`{|}~^-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regex.test(String(email).toLowerCase());
  },

  isValidEmails(email) {
    if (email === undefined || email === "") return true;
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(String(email).toLowerCase());
  },

  isValidEmails1(email) {
    if (email === undefined || email === "") return true;
    // Check email length
    if (email.length > 36) {
      return false;
    }
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(String(email).toLowerCase());
  },

  isValidMobile(mobile) {
    if (mobile === undefined || mobile === "") return true;
    const re = /^(\+\d{1,3}[- ]?)?\d{8,15}$/;
    return re.test(String(mobile));
  },

  isExceptNumericName(name) {
    if (name === undefined || name === "") return true;
    let finalString = name.replace(/[^\d.-]/g, "");
    return finalString;
  },

  isValidName(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[a-zA-Z0-9]+[\'\s]?[a-zA-Z0-9 ]+$/;
    return regex.test(name);
  },

  isValidNames(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[a-zA-Z_0-9 ]+$/;
    return regex.test(name);
  },

  isAlphaNumeric(data) {
    if (data === undefined || data === "") return true;
    var regex = /^[a-zA-Z0-9]+$/i;
    return regex.test(data);
  },

  isValidNumericName(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[A-Za-z0-9 ]+$/;
    return regex.test(name);
  },

  isValidLowerCase(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[a-z]+$/;
    return regex.test(name);
  },
  isValidUpperCase(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[A-Z]+$/;
    return regex.test(name);
  },

  isValidNumeric(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[0-9\. ]+$/;
    return regex.test(name);
  },

  isValidDomain(domain) {
    if (domain === undefined || domain === "") return true;
    var regex = /[a-zA-Z]+[.]+[a-z]+$$/;
    return regex.test(domain);
  },

  isValidPasitiveNumeric(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[0-9]+$/;
    return regex.test(name);
  },
  isValidDoubleValue(value) {
    if (value === undefined || value === "") return true;
    var regex = /^[+-]?([1-9][0-9]*|0)(\.[0-9]+)?((e|E)[+-]?[0-9]+)?$/;
    return regex.test(value);
  },

  isValidCode(code) {
    if (code === undefined || code === "") return true;
    var regex = /^[a-zA-Z0-9_-]*$/;
    return regex.test(code);
  },
  isValidZipcode(areaCode) {
    if (
      areaCode.length < 5 ||
      areaCode.length > 6 ||
      !areaCode.match(/^[0-9 ]+$/)
    )
      return true;
  },
  isAlphaNumericSlash(code) {
    if (code === undefined || code === "") return true;
    var regex = /^(?:[A-Za-z0-9]+)(?:[A-Za-z0-9 _]*)$/;
    return regex.test(code);
  },

  isEmptyString(val) {
    if (val === null || val === undefined || val === "") return true;
    else return false;
  },
  isAlphaNumericSpace(data) {
    if (data == undefined || data === "") return true;
    var regex = /^[a-zA-Z0-9_ ]+$/i;
    return regex.test(data);
  },
  isAlphaNumericSpecialChar(data) {
    if (data == undefined || data === "") return true;
    var regex = /^[ A-Za-z0-9_@./#&+-]*$/;
    return regex.test(data);
  },

  isValidNumeric(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[0-9\. ]+$/;
    return regex.test(name);
  },

  isValidNumericWithSpace(name) {
    if (name === undefined || name === "") return true;
    var regex = /^[0-9][ -]*[0-9]+$/;
    return regex.test(name);
  },

  isEmptyArray(ary) {
    try {
      if (ary === null || ary.length < 1) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return true;
    }
  },

  formatDayAndMonth(numValue) {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  },

  getLocalDateAndTimeGmt(Date) {
    var local = moment
      .utc(Date)
      .local()
      .format("DD-MM-YY HH:mm");
    return local;
  },

  getLocalDateTimeInYearFormat(Date) {
    var local = moment
      .utc(Date)
      .local()
      .format("YYYY-MM-DD HH:mm:ss");
    return local;
  },

  getLocalDateTimeInYearFormat1(Date) {
    var local = moment
      .utc(Date)
      .local()
      .format("MM-DD-YY HH:mm:ss");
    return local;
  },

  getLocalTimes(date) {
    var local = moment
      .utc(date)
      .local()
      .format("HH:mm:ss");
    return local;
  },

  convertTimeAccordingToTimeZone(dateAndTime, offsetStr) {
    console.log("📥 Original input dateAndTime:", dateAndTime);
    console.log("📥 Provided offsetStr:", offsetStr);

    if (!dateAndTime.endsWith("Z")) {
      dateAndTime += "Z";
    }

    if (!offsetStr) {
      offsetStr = moment().format("Z");
      console.log("🌐 Using system's local time zone offset:", offsetStr);
    } else {
      const match = offsetStr.match(/^([+-])(\d{1,2}):(\d{2})$/);
      if (match) {
        const [, sign, hour, minute] = match;
        const paddedOffset = `${sign}${hour.padStart(2, "0")}:${minute}`;
        offsetStr = paddedOffset;
      }
    }

    console.log("🛠️  Final offset to apply:", offsetStr);
    console.log("📦 Moment.js version:", moment.version);
    console.log(
      "✅ Valid offset format test:",
      /^[-+]\d{2}:\d{2}$/.test(offsetStr),
    );

    const momentUtc = moment.utc(dateAndTime);
    console.log("🕓 Parsed UTC moment:", momentUtc.format());

    const converted = momentUtc.utcOffset(offsetStr, false);
    console.log("📤 Converted time with offset:", converted.format());

    const formattedOutput = converted.format("YYYY-MM-DD HH:mm:ss");
    console.log("✅ Final formatted output:", formattedOutput);

    return formattedOutput;
  },

  formatToUtc(date) {
    if (date) {
      var local = moment.tz(
        date,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      );
      var utc = moment.utc(local);
      return utc.format();
    } else {
      return date;
    }
  },

  formatLocalDateTime(date) {
    if (date) {
      return moment(date).format("YYYY-MM-DDTHH:mm:ss");
    }

    return moment().format("YYYY-MM-DDTHH:mm:ss");
  },

  isEmpty(obj) {
    if (obj === null || obj === undefined || obj === "") return true;
    return Object.keys(obj).length === 0;
  },
  getCompany() {
    return localStorage ? localStorage.getItem("companyId") : null;
  },

  getLocalDate(date) {
    var newDate = new Date(date);
    var formated =
      newDate.getFullYear() +
      "-" +
      (newDate.getMonth() + 1) +
      "-" +
      newDate.getDate() +
      " " +
      (newDate.getHours() < 10
        ? "0" + newDate.getHours()
        : newDate.getHours()) +
      ":" +
      (newDate.getMinutes() < 10
        ? "0" + newDate.getMinutes()
        : newDate.getMinutes());
    return formated;
  },

  getDateOfJoining(date) {
    var newDate = new Date(date);
    var formated =
      newDate.getFullYear() +
      "-" +
      (newDate.getMonth() + 1 < 10
        ? "0" + (newDate.getMonth() + 1)
        : newDate.getMonth() + 1) +
      "-" +
      (newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate());
    return moment(formated).format("DD-MM-YY");
  },

  getLocalDate1(date) {
    var newDate = new Date(date);
    return newDate
      .toISOString()
      .replace("T", " ")
      .substr(0, newDate.toISOString().lastIndexOf(":"));
  },

  getLocalTime(time) {
    var newTime = new Date(parseInt(time));
    return newTime.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    });
  },

  TreeDataFormat(arr) {
    var arr1 = [];
    for (var i = 0; i < arr.length; i++) {
      var obj = {};
      obj["value"] = arr[i].id;
      obj["label"] = arr[i].name;
      obj["parentid"] = arr[i].parentId;
      arr1.push(obj);
    }
    var tree = [],
      mappedArr = {},
      arrElem,
      mappedElem;

    // First map the nodes of the array to an object -> create a hash table.
    for (var k = 0, len = arr1.length; k < len; k++) {
      arrElem = arr1[k];
      mappedArr[arrElem.value] = arrElem;
      mappedArr[arrElem.value]["children"] = [];
    }

    for (var value in mappedArr) {
      if (mappedArr.hasOwnProperty(value)) {
        mappedElem = mappedArr[value];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.parentid) {
          try {
            mappedArr[mappedElem["parentid"]]["children"].push(mappedElem);
          } catch (err) {}
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  },

  ZoneDataFormat(arr) {
    var arr1 = [];
    for (var i = 0; i < arr.length; i++) {
      var obj = {};
      obj["key"] = arr[i].id;
      obj["value"] = arr[i].id;
      obj["title"] = arr[i].name;
      obj["parentid"] = arr[i].parentId;
      arr1.push(obj);
    }
    var tree = [],
      mappedArr = {},
      arrElem,
      mappedElem;

    // First map the nodes of the array to an object -> create a hash table.
    for (var k = 0, len = arr1.length; k < len; k++) {
      arrElem = arr1[k];
      mappedArr[arrElem.value] = arrElem;
      mappedArr[arrElem.value]["children"] = [];
    }

    for (var value in mappedArr) {
      if (mappedArr.hasOwnProperty(value)) {
        mappedElem = mappedArr[value];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.parentid) {
          mappedArr[mappedElem["parentid"]]["children"].push(mappedElem);
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  },
  sentenceCase(str) {
    if (str === null || str === "") return false;
    else str = str.toString();

    return str.replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  getDefaultCountryCode() {
    var countryCode = "";
    if (localStorage.getItem("locationInfo")) {
      countryCode = JSON.parse(
        localStorage.getItem("locationInfo"),
      ).country_code.toLowerCase();
    }
    return countryCode;
  },
  getDefaultCallingCountryCode() {
    var countryCallingCode = "";
    if (localStorage.getItem("locationInfo")) {
      countryCallingCode = JSON.parse(
        localStorage.getItem("locationInfo"),
      ).country_calling_code.toLowerCase();
    }
    return countryCallingCode;
  },
  isValidPassword(password) {
    if (password === undefined || password === "") return true;
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return re.test(String(password));
  },
  getLocationDetails(query) {
    var res = "";
    if (localStorage.getItem("locationInfo")) {
      var location = JSON.parse(localStorage.getItem("locationInfo"));
      switch (query) {
        case "ip": {
          res = location.ip;
          break;
        }
        case "latitude": {
          res = location.latitude;
          break;
        }
        case "longitude": {
          res = location.longitude;
          break;
        }
        case "country_code": {
          res = location.country_code;
          break;
        }
        case "country_name": {
          res = location.country_name;
          break;
        }
        case "country_calling_code": {
          res = location.country_calling_code;
          break;
        }
      }
    }
    return res;
  },
  cmdResponseCode: {
    "0": "Success",
    "-1": "Failed to send the command",
    "-2": "No response to the command",
    "-3": "Insufficient cache",
    "-4": "Failed to decompress",
    "-5": "Incorrect length of read data",
    "-6": "The length after decompression does not meet the required one",
    "-7": "Repeated command",
    "-8": "Unauthorized connection",
    "-9": "Incorrect data. CRC failed",
    "-10":
      "Incorrect data. Failed to resolve data API -11 Incorrect data parameter",
    "-12": "Command execution error",
    "-13": "Incorrect command. The command does not exit",
    "-14": "Incorrect communication password",
    "-15": "Failed to write the file",
    "-16": "Failed to read the file",
    "-17": "The file does not exist",
    "-18": "The device has insufficient space",
    "-19": "Checksum error",
    "-20":
      "The length of the received data is inconsistent with the specified data length",
    "-21": "No platform parameter is set on the device",
    "-22":
      "The received firmware platform for upgrade is not same to the local platform",
    "-23":
      "The firmware version for upgrade is earlier than that in the device",
    "-24": "Incorrect flag of the upgrade file",
    "-25": "The name of the received file for firmware upgrade is not emfw.cfg",
    "-26": "The length of the received fingerprint template is 0",
    "-27":
      "The PIN of the received fingerprint template is incorrect. Failed to find the user. ",
    "-28": "Door opening command is executed during the open time period.",
    "-30": "The integrated template algorithm’s version is inconsistent",
    "-100": "The table structure does not exist",
    "-101": "The conditional field in the table structure does not exist",
    "-102": "The total field count is inconsistent",
    "-103": "The field sequence is inconsistent",
    "-104": " Incorrect real-time event data",
    "-105": "Incorrect data for resolution",
    "-106": "The size of the delivered data exceeds 4 MB",
    "-107": "Failed to get the table structure",
    "-108": "Invalid OPTIONS",
    "-201": "LoadLibrary failed",
    "-202": "Failed to call the interface",
    "-203": "Communication initialization failed",
    "-206":
      "Failed to start the serial port agent program. A general cause is that the serial portdoes not exist or has been occupied",
    "-301": "Failed to get the TCP/IP version",
    "-600":
      "is a returned value exclusive to push communication(Return value already mentioned above cannot be defined repeatedly)",
    "-601": "Reserved. For firmware internal use only",
    "-603": "Internal error: invalid handle",
    "-604": "Insufficient memory",
    "-609": "Internal error: invalid handle",
    "-612": "The device failed to save the parameter",
    "-614": "Failed to remotely cancel the alarm",
    "-615": "Remote restart failed",
    "-616": "Remotely enabling or canceling normal open failed",
    "-618": "Incorrect URL format",
    "-619": "Firmware internal error: blank input parameter",
    "-620": "The format of the data delivered by the server is incorrect",
    "-621": "The table structure does not support this field",
    "-628": "Main failed to load the fingerprint to the memory",
    "-629": "Incorrect table name",
    "-630": "Failed to execute the shell command",
    "-631": "Incorrect base64 length",
    "-632": "Incorrect file name",
    "-701": "Reserved. For firmware internal use only",
    "-702": "Reserved. For firmware internal use only",
    "-703": "Reserved. For firmware internal use only",
    "-704": "Reserved. For firmware internal use only",
    "-705": "Reserved. For firmware internal use only",
    "-706": "Reserved. For firmware internal use only",
    "-707": "Reserved. For firmware internal use only",
    "-708": "The firmware does not support this command",
    "-709": "Failed to upload options",
    "-720": "Failed to upgrade the firmware",
    "-721": "The device downloads the file",
    "-722": "Failed to upload the data to the software",
    "-723": "Reserved. For firmware internal use only",
    "-724": "Reserved. For firmware internal use only",
    "-725": "It times out when the device waits for the result",
    "-726": "The server returns an HTTP error",
    "-727": "Reserved. For firmware internal use only",
    "-728": "Failed to upload the number of table data entries",
    "-729": "Reserved. For firmware internal use only",
    "-730": "No response from the server",
    "-731": "An error occurs when the server receives the data",
    "-732": "Reserved. For firmware internal use only",
    "-801": "Incorrect command format. The correct format is cmd:SN:command",
  },
};

export default CommonUtil;
